enum Step {
  INCOMING,
  IN_PROGRESS,
  READY,
}

export default Step
